/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SkuResVo } from './SkuResVo';
import {
    SkuResVoFromJSON,
    SkuResVoFromJSONTyped,
    SkuResVoToJSON,
    SkuResVoToJSONTyped,
} from './SkuResVo';

/**
 * 
 * @export
 * @interface ResponseSkuResVo
 */
export interface ResponseSkuResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseSkuResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseSkuResVo
     */
    message?: string;
    /**
     * 
     * @type {SkuResVo}
     * @memberof ResponseSkuResVo
     */
    data?: SkuResVo;
}

/**
 * Check if a given object implements the ResponseSkuResVo interface.
 */
export function instanceOfResponseSkuResVo(value: object): value is ResponseSkuResVo {
    return true;
}

export function ResponseSkuResVoFromJSON(json: any): ResponseSkuResVo {
    return ResponseSkuResVoFromJSONTyped(json, false);
}

export function ResponseSkuResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseSkuResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : SkuResVoFromJSON(json['data']),
    };
}

export function ResponseSkuResVoToJSON(json: any): ResponseSkuResVo {
    return ResponseSkuResVoToJSONTyped(json, false);
}

export function ResponseSkuResVoToJSONTyped(value?: ResponseSkuResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': SkuResVoToJSON(value['data']),
    };
}

